/* eslint-disable */
import { useEffect, useState } from "react";
import TableStyle from "../style/table.component";
import { Header, TableProps } from "./interface/interface";

const ClubMemberTable = (props: TableProps) => {
  const {
    headers,
    currentPage,
    dataList,
    setDetail,
    setIsOpen,
    size,
    setDataList,
    sortColumn,
    sortDirection,
    onSort,
    rewardFilter,
  } = props;
  const pageSize = size ? size : 10;
  const getDataForPage = (page: number) => {
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataList.slice(startIndex, endIndex);
  };

  const handleHeaderClick = (header: Header) => {
    if (header.sortable && onSort) {
      onSort(header.value);
    }
  };

  const getSortIcon = (header: Header) => {
    if (!header.sortable) return null;

    if (header.value === "isRewarded") {
      switch (rewardFilter) {
        case "Y":
          return " (지급)";
        case "N":
          return " (미지급)";
        default:
          return " (전체)";
      }
    }

    // 일반 정렬 아이콘
    if (sortColumn === header.value) {
      return sortDirection === "asc" ? " ↑" : " ↓";
    }
    return " ↕";
  };
  return (
    <TableStyle marginTop="30px">
      <thead>
        <tr>
          {headers.map((header: Header) => (
            <th
              key={header.value}
              onClick={() => handleHeaderClick(header)}
              style={{
                cursor: header.sortable ? "pointer" : "default",
                userSelect: "none",
              }}
            >
              {header.text}
              {getSortIcon(header)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {getDataForPage(currentPage).map((data: any, index: number) => (
          <tr
            key={index}
            onClick={() => {
              if (setDetail) setDetail(data);
              if (setIsOpen) setIsOpen(true);
            }}
          >
            {headers.map((header) => (
              <td key={header.value}>{data[header.value]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </TableStyle>
  );
};

export default ClubMemberTable;
